import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "14",
            height: "20",
            x: "5",
            y: "2",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12.667 8 10 12h4l-2.667 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SmartphoneCharging";
const SmartphoneCharging = memo(themed(Icon));
export {
  SmartphoneCharging
};
//# sourceMappingURL=smartphone-charging.js.map
